/*
 * Project: LegalPlace assistant
 * File: src/components/variable_container.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { generateId1 } from './utils/misc';
import Variable from './variable';
import lpApp from '../app/lp_app';


export class _VariableContainer extends Component {
  constructor(props) {
    super(props);
    // maybe we don't get real values
    this.params = {
      ...props,
      ...{
        lpKey: generateId1(4),
        is_active: false,
      },
    };

    if (!this.params.variables) {
      this.params.variables = [];
    }
  }

  componentWillMount() {
    this.props.initializeFlat(this.params.lpKey, this.params.parent, 'vc', this.props.sectionId, -3, this.props.lpParent);
    // console.log("> " + this.params.lpKey + " > " + this.params.lpParent);
    // FIXME: test if this exists in the flat before adding it.

    this.state = {
      shown: true,
    };
  }

  componentDidMount() {
    // console.log(this.props)

  }

  // style={'show' in this.props &&
  // this.props.show ? style_show : style_hide}
  render() {
    // console.log("jdjdjjd")
    const isCopy = ('is_copy' in this.params && this.params.is_copy);
    const isStatic = (lpApp.references.getOption(this.props.id).meta.type === 'static') && this.props.variables && this.props.variables.length > 0;
    const hasVariables = this.props.variables && this.props.variables.length > 0;
    // <AnimateHeight height={height} duration={2000}>
    // </AnimateHeight>
    return (
      <div
        className={!isStatic ? `wzog-content${!hasVariables ? ' wz-empty' : ''}` : 'wzog-wrapper'}

        key={generateId1(4)}
        data-type="variable-container"
        data-id={this.props.id}
        data-is-duplicate={this.props.isDuplicate}
        data-copy={this.props.copy}
      >
        {this.params.variables.map(idx => <Variable
          lpKey={this.props.lpKey}
          lpParent={this.props.lpParent}
          id={idx.id}
          parent={this.props.id}
          key={generateId1(4)}
          label={idx.label}
          type={idx.type}
          helper={idx.helper}
          autocomplete={idx.autocomplete ? idx.autocomplete : 'off'}
          is_copy={isCopy}
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          copy={this.props.copy}
        />, this)}

      </div>
    );
  }
}

// we have to in the VC into the flatui
const mapStateToProps = state => ({
  sectionId: state.contract.currentSection,
});

const mapDispatchToProps = () => ({
  initializeFlat: (ui, id, genre, sectionId, parentId, parentui) => {
  },
});

export const VariableContainer = connect(mapStateToProps, mapDispatchToProps)(_VariableContainer);



// WEBPACK FOOTER //
// ./src/components/variable_container.js